import { render, staticRenderFns } from "./AbonnementStatus.vue?vue&type=template&id=0973652a"
import script from "./AbonnementStatus.vue?vue&type=script&lang=js"
export * from "./AbonnementStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports